import React, { useState, useEffect } from 'react'
import { message, } from 'antd'
import Icon from '../icon'
import AuthorityIntroduced from '../authorityIntroduced'
import Modal from '../modal'
import Input from '../../baseComponent/input'
import DeleteColl from '../deleteColl'
import util from '../../utils/util'
import Loading from '../../baseComponent/loading'
import versionNumber from '../useFunModal/versionNumber'
import useVersionNumber from '../../common/hooks/useVersionNumber'
import request from '../../utils/request'
import './index.less'
import ChildCooperation from './childCooperation'
import { IDEA_MASS_ROLE } from '../enum'

export default (props) => { // 新建或者编辑子灵感集
  const { children, onClick, style, className, parentId, onChange, inspirationId, onDelete, currentRole, isCreate, auth } = props
  const [visible, setVisible] = useState(false)

  const { isAuthLimit } = useVersionNumber({
    inspirationId: parentId
  }, [visible])

  const onClickTrigger = async (e) => {
    e && e.stopPropagation()
    if (!isAuthLimit('meinian_inspiration_child_limit')) {
      versionNumber({
        title: '子灵感集'
      })
      return
    }
    const flag = await onClick?.()
    if (flag === false) {
      return
    }
    setVisible(true)
  }
  return <>
    <a onClick={onClickTrigger} style={style} className={className}>{children || '新建灵感集'}</a>
    {
      visible && <CreateOrEditChild
        visible={visible}
        parentId={parentId}
        setVisible={setVisible}
        inspirationId={inspirationId}
        onChange={onChange}
        onDelete={onDelete}
        currentRole={currentRole}
        isCreate={isCreate}
        auth={auth}
      />
    }
  </>
}

export const CreateOrEditChild = (props) => {
  const { visible, setVisible, parentId, inspirationId, onChange, onDelete, currentRole, isCreate = true, auth = [], onCancel, onOk } = props
  const [ideaMass, setIdeaMass] = useState({})
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(inspirationId)
  const [cooperationLoading, setCooperationLoading] = useState(true)

  useEffect(() => {
    inspirationId && fetchIdeaMass()
  }, [])

  const fetchIdeaMass = async () => {
    setLoading(true)
    try {
      const res = await request.get('/zhikuan/ins/inspiration/get-inspiration-info', { params: { inspirationId } })
      setIdeaMass(res)
    } catch (err) {
      console.error('/zhikuan/ins/inspiration/get-inspiration-info', err)
    }
    setLoading(false)
  }

  const create = async () => {
    const res = await request.post('/zhikuan/ins/inspiration/save-inspiration-info', {
      ...ideaMass,
      parentId,
      cooperationUserList: users?.filter(item => item.roleInherit === true)?.map(m => ({
        role: m.role,
        userId: m.userId,
      }))
    })
    message.success(<span>已成功新建灵感集<a className="link" style={{ color: '#0065D9' }} href={`/meinian/home/coll/detail/${res}?inspirationId=${res}`} target="_blank" rel="noreferrer">{ideaMass.name}</a></span>)
    util.track('mn-add-children-inspiration', {
    })
    onChange?.(res, { ...ideaMass, id: res }) // 返回创建成功的id
  }
  const edit = async () => {
    const res = await request.post('/zhikuan/ins/inspiration/modify-inspiration-info', {
      ...ideaMass
    })
    onChange?.(res, { ...ideaMass, id: res }) // 返回创建成功的id
  }

  const onSubmit = async () => {
    if (!ideaMass.name?.trim()) {
      message.error('灵感集的名称不能为空哦')
      return false
    }
    const reg = /(^(ht|f)tps?:)\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
    if ((ideaMass.relatedInspiration && !ideaMass.relatedInspiration.match(reg)) || (ideaMass.relatedShop && !ideaMass.relatedShop.match(reg))) {
      message.error('请输入正确的网址')
      return false
    }
    ideaMass.id ? edit() : create()
    const flag = await onOk?.()
    if (flag === false) {
      return
    }
    setVisible(false)
  }
  const onDeleteIns = () => {
    onDelete?.(ideaMass)
    setVisible(false)
  }

  return <Modal
    title={ideaMass.id ? '编辑子灵感集' : '新建子灵感集'}
    className="mn-create-or-edit-child-idea-mass-modal"
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
    onCancel={onCancel}
    style={{ width: 640 }}
    onOk={() => onSubmit()}
  >
    <Loading spinning={loading || cooperationLoading}>
      <div className="content">
        <div className="item-name required">名称</div>
        <Input
          wrapClassName="item-input"
          disabled={!isCreate && !(auth.includes('FC04') || auth.includes('FC04_CREATOR'))}
          maxLength={20}
          value={ideaMass.name}
          placeholder="请输入灵感集名称，不超过20个字"
          onChange={(e) => { const name = e.target.value; setIdeaMass(pre => ({ ...pre, name })) }}
          suffix={`${ideaMass?.name?.length || 0}/20`}
        />
        <div className="item-name">简介</div>
        <Input
          wrapClassName="item-input"
          disabled={!isCreate && !(auth.includes('FC04') || auth.includes('FC04_CREATOR'))}
          maxLength={50}
          value={ideaMass.introduction}
          placeholder="请输入简介，不超过50个字"
          onChange={(e) => { const introduction = e.target.value; setIdeaMass(pre => ({ ...pre, introduction })) }}
          suffix={`${ideaMass?.introduction?.length || 0}/50`}
        />
        <div className="mn-install-cooperation">
          <div className="item-name">设置协作</div>
          <div className="information-permissions">
            <span>权限说明</span>
            <AuthorityIntroduced placement="bottomRight" currentRole={currentRole || ideaMass?.loginUserInfo?.role}>
              <Icon style={{ marginLeft: 4, verticalAlign: 'text-bottom', fontSize: 16, color: '#b8b8b8', cursor: 'pointer' }} type="m-xinxi_miaobian" />
            </AuthorityIntroduced>
          </div>
        </div>
        <ChildCooperation
          onChange={(_users) => { setUsers(_users); setCooperationLoading(false) }}
          id={inspirationId}
          parentId={parentId}
          setLoading={ideaMass.id && setLoading}
        />
      </div>
    </Loading>
    {loading || !ideaMass.id || ideaMass.loginUserInfo.role !== IDEA_MASS_ROLE.OWNER ? null
      : !ideaMass.isDefault && <div
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.stopPropagation()
            DeleteColl({
              params: { inspirationId: ideaMass.id }, onDelete: () => onDeleteIns() })
          }}
          className="delete"
      >删除灵感集</div>}
  </Modal>
}
